import type { FaireProductEntity } from "../../entity_types/product";

export const p_1aexb578km: FaireProductEntity = {
  token: "p_1aexb578km",
  type: "product",
  name: "Straw Hat // Sun Hat // Baby Sun Hat // Beach Hat",
  brandToken: "b_75hpx939",
  brandName: "Babe Basics",
  imageUrl:
    "https://cdn.faire.com/fastly/67fb61bf285f49801b1558b94cdd51913cc9801fad72ec49673d57d7574edb63.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6f9f3f53004ceae0babbcef9305f77aa4f49d42e60d75631cc0a75717c32478b.jpeg",
    "https://cdn.faire.com/fastly/58c52ce26b40550b3d512536b77374b25c8df31835643db8bfed5af6d91e140e.jpeg",
    "https://cdn.faire.com/fastly/1c60cb06debb94e8411e84408ff727c9433b648e385ab65cf0ba3f514c3b79b9.jpeg",
    "https://cdn.faire.com/fastly/86b3d8fe12cc61272a61e9a33a04e64bc06788dbc410f30277b419896f6f316e.jpeg",
    "https://cdn.faire.com/fastly/2443dd06edb9dbca10304ad2d7e89ba294daf651663a19f3c82b74147f0fcd3d.jpeg",
    "https://cdn.faire.com/fastly/3794d220618bfb9ddfdbc7423f357ff67afae628434e864f117633f5f0868dd7.jpeg",
  ],
  priceDollars: 11,
  description:
    "Timeless, fashionable, and so useful, this woven straw baby hat will keep your babe's face protected from the sun all day. This baby hat is perfect for a picnic or afternoon at the beach and will grow with baby. One size - adjust the size by pulling the drawstring to keep this hat around for multiple seasons!\n\nCream: light color, natural: darker color\n\nFits 0-3 years with an adjustable drawstring. \n\nImported.",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:25:48.781Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
